// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,500;1,400&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Pacifico&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

body {
  width: 100%;
  height: 100%;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 12px;
  font-weight: 550;
  color: #fff;
  background-color: #252B48;
}

main {
  width: 100%;
  margin: 0 auto;
}

button, a, input, textarea {
  min-width: 44px;
  min-height: 44px;
  margin: 8px;
}

.content {
  padding: 32px;
  margin: 0 auto; 
}`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAGA;EACE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;AAChB","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,500;1,400&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Pacifico&display=swap');\n\n* {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  width: 100%;\n  height: 100%;\n  font-family: \"Plus Jakarta Sans\", sans-serif;\n  font-size: 12px;\n  font-weight: 550;\n  color: #fff;\n  background-color: #252B48;\n}\n\nmain {\n  width: 100%;\n  margin: 0 auto;\n}\n\nbutton, a, input, textarea {\n  min-width: 44px;\n  min-height: 44px;\n  margin: 8px;\n}\n\n.content {\n  padding: 32px;\n  margin: 0 auto; \n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
